import { FC } from 'react'
import { connectRefinementList } from 'react-instantsearch-dom'
import { SearchFiltersHumanizedRefinement } from 'search'
import { Card as BaseCard } from 'shared/components/CardDeprecated'
import styled from 'styled-components'
import { SearchQA } from 'shared/dataAttributes'

import { IRefinementListProps } from '../IRefinementListProps'
import DesktopBrandFilter from './DesktopBrandFilter'
import MobileBrandFilter from './MobileBrandFilter'
import sendTrackingEvent from 'mParticle/sendTrackingEvent'

const Card = styled(BaseCard)<{ isHidden: boolean }>`
  display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
`
export const BrandFilter: FC<IRefinementListProps> = ({ items, refine, attribute, hide }) => {
  const handleRefinement = (value: string) => {
    sendTrackingEvent('FILTER_APPLY_TAP', {
      page: window?.location?.href,
      filter_name: SearchFiltersHumanizedRefinement()[attribute].toLowerCase(),
      filter_selection: value[value.length - 1],
    })
    refine(value)
  }
  return items.length > 0 ? (
    <Card
      title={SearchFiltersHumanizedRefinement()[attribute]}
      isExpanded
      isHidden={hide}
      qaAttr={SearchQA.FilterBrand}
    >
      <MobileBrandFilter items={items} refine={handleRefinement} />
      <DesktopBrandFilter items={items} refine={handleRefinement} />
    </Card>
  ) : null
}

BrandFilter.displayName = 'BrandFilterContainer'

export default connectRefinementList(BrandFilter)
